import { useQuery } from '@tanstack/react-query'

import { PostLoansDownsellResponse } from '@api/postLoansDownsell'

import { useBasin } from '@hooks/useBasin'

import getAuthHeaders from './utils/getAuthHeaders'
import { handleApiResponse } from './utils/handleApiResponse'

export interface LoansDownsellQueryOptions {
    customerId: string | undefined
    shouldFetch: boolean
}

export const useLoansDownsellQuery = ({
    customerId,
    shouldFetch,
}: LoansDownsellQueryOptions) => {
    const { ids } = useBasin()

    return useQuery<PostLoansDownsellResponse>(
        ['loansDownsell', customerId],
        () =>
            fetch(`${process.env.NEXT_PUBLIC_BASE_PATH}/api/loans-downsell/`, {
                body: JSON.stringify({ customerId }),
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                    ...getAuthHeaders(ids),
                },
            }).then(handleApiResponse),
        {
            staleTime: Infinity,
            refetchOnWindowFocus: false,
            retry: 3,
            enabled: !!customerId && shouldFetch,
        }
    )
}
